import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Btn } from "@/components/common";
import { eur } from "@/lib/api";
import { Send } from "lucide-react";

const inp = "w-full px-3 py-2 text-sm rounded-md border border-slate-300 bg-white";

const defaultTemplate = (g, link) =>
  `Ciao ${g.title}! Grazie per aver soggiornato al Blu Lodge Maldives, speriamo di rivederti presto.\nEcco il ricordo della tua vacanza: guarda l'anteprima delle foto e dei video e acquista il pacchetto completo (${eur(g.price)}) qui:\n${link}`;

export const paidTemplate = (g, link) =>
  `Ciao ${g.title}! Grazie per aver soggiornato al Blu Lodge Maldives, speriamo di rivederti presto.\nEcco il ricordo della tua vacanza: scarica tutte le foto e i video del tuo soggiorno qui:\n${link}`;

export default function WaSendDialog({ g, link, open, onClose, template = defaultTemplate }) {
  const [phone, setPhone] = useState(g.client_phone || "");
  const [text, setText] = useState(template(g, link));
  const num = phone.replace(/[^\d]/g, "").replace(/^00/, "");
  const send = () => {
    window.open(`https://api.whatsapp.com/send?phone=${num}&text=${encodeURIComponent(text)}`, "_blank");
    onClose();
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="wa-dialog">
        <DialogHeader><DialogTitle>Invia il link su WhatsApp</DialogTitle></DialogHeader>
        <label className="text-xs font-semibold text-slate-600">Numero WhatsApp (con prefisso, es. +39 333 1234567)</label>
        <input data-testid="wa-phone" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="+39 333 1234567" className={inp} />
        <label className="text-xs font-semibold text-slate-600 mt-2">Messaggio</label>
        <textarea data-testid="wa-text" value={text} onChange={(e) => setText(e.target.value)} rows={7} className={inp} />
        <div className="flex justify-between gap-2 mt-2">
          <button data-testid="wa-reset" onClick={() => setText(template(g, link))} className="text-xs text-sky-700 font-semibold">Ripristina testo</button>
          <Btn data-testid="wa-send" onClick={send} disabled={num.length < 7}><Send size={14} /> Apri WhatsApp</Btn>
        </div>
      </DialogContent>
    </Dialog>
  );
}
